import Vue from 'vue';

Vue.filter('imgHome', (value, noCache = false) => {
  let url = `${process.env.VUE_APP_STORAGE_URL}${value}`;
  if (noCache) {
    if (url.indexOf('?') > -1) {
      return `${url}&_timestamp=${new Date() * 1}`;
    }
    return `${url}?_timestamp=${new Date() * 1}`;
  }
  return url;
});

Vue.filter('subStr', (value, length = 10) => {
  if (value && value.length > length) {
    value = `${value.substring(0, length)}...`;
  }
  return value;
});
